import { ReactComponent as SVGAMEX } from '../Assets/creditCardIcons/AMEX.svg'
import { ReactComponent as SVGVISA } from '../Assets/creditCardIcons/VISA.svg'
import { ReactComponent as SVGJCB } from '../Assets/creditCardIcons/JCB.svg'
import { ReactComponent as SVGMC } from '../Assets/creditCardIcons/MC.svg'
import { observer } from 'mobx-react-lite'

const AMEX = () => <SVGAMEX />
const VISA = () => <SVGVISA />
const JCB = () => <SVGJCB />
const MC = () => <SVGMC />

export default observer(props => {
    switch (props.icon) {
        case 'AMEX':
            return <AMEX />
        case 'VISA':
            return <VISA />
        case 'JCB':
            return <JCB />
        case 'MC':
            return <MC />
        default:
            return null
    }
})
